import { io } from "socket.io-client";
import { config } from './Components/CustomComponents/config';

let Api=config.Api.split('/api')[0]
const socket = io(Api, {
  transports: ["websocket"],
});

export default socket;
